const PublisherModuleDetail = {
    title: 'Access Manager',
    nav: [
        {
            name: 'Permissions',
            url: 'permissions',
            groupsAllowed: ['portal-hello-module-admin'],
        },
    ],
    loadModule: () => import('./bigfishgames-access-manager-portal-module.module-18688c2f.mjs').then((m) => m.PortalModule),
};

/*
 * Public API Surface of hello-module
 */

/**
 * Generated bundle index. Do not edit.
 */

export { PublisherModuleDetail };
